import { apiClient } from '@/config/api';
import { TrendingMoviesWithDetails, UpdateTrendingMoviesDto, TrendingType } from '@/types/trending-movies';

class TrendingMoviesService {
  // Lấy danh sách phim theo type
  async getTrendingMovies(type: TrendingType = TrendingType.TRENDING): Promise<TrendingMoviesWithDetails> {
    const response = await apiClient.get('/trending-movies', { type });

    if (!response.ok) {
      throw new Error(response.data?.message || 'Lỗi khi lấy danh sách phim');
    }

    if (!response.data?.data) {
      throw new Error('Không có dữ liệu phim');
    }

    return response.data.data;
  }

  // Cập nhật danh sách phim thịnh hành
  async updateTrendingMovies(updateDto: UpdateTrendingMoviesDto): Promise<TrendingMoviesWithDetails> {
    const response = await apiClient.put('/trending-movies', updateDto);

    if (!response.ok) {
      throw new Error(response.data?.message || 'Lỗi khi cập nhật phim thịnh hành');
    }

    if (!response.data?.data) {
      throw new Error('Không có dữ liệu phim thịnh hành sau khi cập nhật');
    }

    return response.data.data;
  }
}

export const trendingMoviesService = new TrendingMoviesService();
